module.exports = __webpack_public_path__ + "img/upper pocket bag height.cc5af427.png";